import React, { useState, useCallback, useEffect } from 'react'
import { useHistory } from 'react-router'
import { Card } from 'reactstrap'
import { TitlePage } from 'components/atoms'
import CustomerRefundVoucherTable from 'domains/customer-refund-voucher/organisms/table'
import CustomerRefundVouchersApiV2 from 'api/v2/admins/customer-refund-vouchers-api-v2'
import PropTypes from 'prop-types'
import Collapsible from 'components/molecules/collapsible'
import CustomerRefundVoucherFilterForm from 'domains/customer-refund-voucher/filter-form'
import ParamsUtil from 'utils/params-util'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const defaultProps = {
  pageUtils: {
    setAlertMsg    : () => {},
    setApiErrorMsg : () => {}
  }
}

const DEFAULT_FILTERS = {
  number   : '',
  status   : '',
  page     : 1,
  per_page : 10
}

const CustomerRefundVoucherListPage = ({ pageUtils }) => {

  const hiddenColumns                         = []
  const history                               = useHistory()
  const [ refundVouchers, setRefundVouchers ] = useState([])
  const [ pagination, setPagination ]         = useState({})
  const [ isLoading, setIsLoading ]           = useState(false)

  const filters  = Object.fromEntries(new URLSearchParams())
  const pathName = Object.fromEntries(new URLSearchParams()).pathname

  useEffect(() => {
    handleFetchRefundVouchers()
  }, [  ]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleFetchRefundVouchers = async () => {
    setIsLoading(true)

    let params          = DEFAULT_FILTERS
    const isEmptyParams = Object.keys(filters).length === 0

    if (!isEmptyParams) {
      params = filters
    }

    await CustomerRefundVouchersApiV2.get({  ...params  })
      .then((response) => {
        const data = response.data.refund_vouchers
        const meta = response.data.meta
        setRefundVouchers(data)
        setPagination(meta)
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
      .finally(() => setIsLoading(false))
  }

  // Goes to Refund with Voucher Code detail Page when clicking on the row button
  const handleSelectRow = useCallback((orderId) => {

    history.push({
      pathname: `refund-vouchers/${orderId}`
    })
  }, [ history ])

  const handlePageChange = (page) => {
    const params = filters
    //replace page value
    params[ 'page' ] = page

    history.push({
      pathname : pathName,
      search   : new URLSearchParams(params).toString()
    })
  }

  const handleSubmitFilter = (values, formik) => {
    //remove empty attributes from params
    let params = ParamsUtil.removeEmptyAttributes(values)
    //reset page
    params = ParamsUtil.removeAttributeFromObject('page',params)

    history.push({
      pathname : pathName,
      search   : new URLSearchParams(params).toString()
    })

    formik.setSubmitting(false)
  }

  const handleResetFilter = () => history.push({ pathname: pathName })

  return (
    <>
      <TitlePage mainTitle='Refund With Voucher Code' />
      <Card body>
        <Collapsible header='Filters' isOpen={ true }>
          <CustomerRefundVoucherFilterForm
            onClickSubmitForm={ handleSubmitFilter }
            filterValues={ filters }
            onClickReset={ handleResetFilter }
            hiddenColumns={ hiddenColumns }
          />
        </Collapsible>
      </Card>
      <Card>
        <CustomerRefundVoucherTable
          tableProps={{
            size       : 'sm',
            responsive : true,
            hover      : true
          }}
          refundVouchers = { refundVouchers }
          pagination={ pagination }
          isLoading={ isLoading }
          onPageChange={ handlePageChange }
          hiddenColumns={ hiddenColumns }
          onClickRow = { handleSelectRow }
        />
      </Card>
    </>
  )
}

CustomerRefundVoucherListPage.propTypes    = propTypes
CustomerRefundVoucherListPage.defaultProps = defaultProps

export default CustomerRefundVoucherListPage
